import { render, staticRenderFns } from "./RsaPazienteRiepilogoOperatoriAttivitaListModalComponent.vue?vue&type=template&id=4a0cf4e6&scoped=true"
import script from "./RsaPazienteRiepilogoOperatoriAttivitaListModalComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteRiepilogoOperatoriAttivitaListModalComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaPazienteRiepilogoOperatoriAttivitaListModalComponent.vue?vue&type=style&index=0&id=4a0cf4e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0cf4e6",
  null
  
)

export default component.exports